<template>
    <!-- Zeigt Inhalte nur, wenn data existiert und cards vorhanden sind -->
    <div v-if="data && data.cards && data.cards.length > 0">
      <vue-horizontal>
        <section
          v-for="item in data.cards"
          :key="item.id"
          class="item-container"
          :style="getProductContainerStyle(item)"
        >
          <!-- Optionales Bild -->
          <div v-if="item.imageUrl" class="image-container">
            <img :src="item.imageUrl" alt="image" class="item-image" />
          </div>
  
          <!-- TEXT -->
          <template v-if="item.type === 'text'">
            <h3 v-if="item.cta_url">
              <a
                :href="item.cta_url"
                class="cta-link"
              >
                {{ item.title }}
              </a>
            </h3>
            <h3 v-else>
              {{ item.title }}
            </h3>
  
            <p
              v-if="item.content"
              class="item-content"
              :style="getStyle('text', 'content')"
            >
              {{ item.content }}
            </p>
          </template>
  
          <!-- PRODUCT -->
          <template v-else-if="item.type === 'product'">
            <h3
              class="product-title"
              :style="getStyle('product', 'title')"
            >
              <template v-if="item.cta_url">
                <a
                  :href="item.cta_url"
                  class="cta-link"
                  :style="getStyle('product', 'ctaLink')"
                >
                  {{ item.title }}
                </a>
              </template>
              <template v-else>
                {{ item.title }}
              </template>
            </h3>
  
            <p
              v-if="item.content"
              class="item-content"
              :style="getStyle('product', 'content')"
            >
              {{ item.content }}
            </p>
  
            <div
              class="old-price"
              v-if="item.oldPrice && item.discount"
              :style="getStyle('product', 'oldPrice')"
            >
              Sonst {{ item.oldPrice }} - {{ item.discount }}%
            </div>
  
            <div
              v-if="item.price"
              class="current-price"
              :style="getStyle('product', 'currentPrice')"
            >
              <span
                class="price"
                :style="getStyle('product', 'price')"
              >
                {{ item.price }}
              </span>
              <span
                class="price-note"
                v-if="item.priceNote"
                :style="getStyle('product', 'priceNote')"
              >
                {{ item.priceNote }}
              </span>
            </div>
  
            <div
              v-if="item.basePrice"
              class="base-price"
              :style="getStyle('product', 'basePrice')"
            >
              {{ item.basePrice }}
            </div>
  
            <div
              v-if="item.shippingInfo"
              class="shipping-info"
              :style="getStyle('product', 'shippingInfo')"
            >
              {{ item.shippingInfo }}
            </div>
          </template>
  
          <!-- BLOG -->
          <template v-else-if="item.type === 'blog'">
            <h3
              class="blog-title"
              :style="getStyle('blog', 'title')"
            >
              <template v-if="item.cta_url">
                <a
                  :href="item.cta_url"
                  class="cta-link"
                  :style="getStyle('blog', 'ctaLink')"
                >
                  {{ item.title }}
                </a>
              </template>
              <template v-else>
                {{ item.title }}
              </template>
            </h3>
  
            <p
              v-if="item.content"
              class="item-content"
              :style="getStyle('blog', 'content')"
            >
              {{ item.content }}
            </p>
          </template>
  
          <!-- FALLBACK (unbekannter type) -->
          <template v-else>
            <h3>{{ item.title }}</h3>
            <p v-if="item.content">
              {{ item.content }}
            </p>
          </template>
        </section>
      </vue-horizontal>
    </div>
    <!-- Falls data leer oder nicht vorhanden -->
    <div v-else>
      <!-- Entweder Leerzustand anzeigen oder einen Loader -->
    </div>
  </template>
  
  <script>
  import VueHorizontal from 'vue-horizontal'
  import axios from 'axios'
  
  export default {
    name: 'DynamicContentBar',
    components: {
      VueHorizontal
    },
    props: {
      sliderId: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        data: null // Hier speichern wir {styles: {...}, cards: [...]}, oder nur {cards: [...]}
      }
    },
    mounted() {
      axios
       .get('https://bobmagblob.blob.core.windows.net/shop/products/product-'+this.sliderId+'.json')
      //  .get('https://bobmagblob.blob.core.windows.net/shop/category/content-1.json')
        .then((response) => {
          // Schau zur Sicherheit nach, was wir bekommen:
          // Wenn du ein Objekt vom Typ { cards: [...], styles: {...} } erwartest:
          this.data = response.data
          // Wenn es nur ein Array ist, könnte man z. B.:
          // this.data = { cards: response.data }
        })
        .catch((error) => {
          console.error('Error fetching data', error)
        })
    },
    methods: {
        getProductContainerStyle(item) {
      // Für Nicht-Products => fallback
      if (item.type !== 'product') {
        return this.getStyle(item.type, 'container')
      }
      // Container-Style definieren
      const base = this.getStyle('product', 'container')

      // Wenn item.selected, "selected"-Style hinzufügen
      if (item.selected) {
        const selected = this.getStyle('product', 'containerSelected')
        // Zusammenführen (Spread-Operator)
        return { ...base, ...selected }
      }
      return base
    },

    getStyle(type, property) {
      if (!this.data || !this.data.styles) return {}
      const typeStyles = this.data.styles[type]
      if (!typeStyles) return {}
      return typeStyles[property] || {}
    }
    }
  }
  </script>
  
  <style scoped>
  /* Standard-Fallback */
  .item-container {
    background-color: #3e9521;
    color: white;
    padding: 10px 4px;
    margin-right: 20px;
    border-radius: 0px;
    width: 25%;
    min-width: 320px;
  }
  .image-container {
    display: flex;
    justify-content: center;
    margin-bottom: 0.5rem;
  }
  .item-image {
    max-width: 100%;
    height: auto;
    object-fit: cover;
  }
  .item-content {
    white-space: pre-wrap;
    text-align: center;
    margin-top: 0.5rem;
  }
  .product-title {
    text-align: center;
    margin-bottom: 0.25rem;
  }
  .old-price {
    text-align: right;
    font-size: 0.9rem;
    color: #fff;
    opacity: 0.8;
    margin-bottom: 0.25rem;
  }
  .current-price {
    text-align: right;
    margin-bottom: 0.25rem;
  }
  .price {
    font-size: 1.5rem;
    color: red;
    margin-right: 0.5rem;
  }
  .price-note {
    font-size: 0.8rem;
    color: black;
  }
  .base-price {
    text-align: right;
    font-size: 0.8rem;
    color: #ffffff;
    opacity: 0.8;
    margin-bottom: 0.25rem;
  }
  .shipping-info {
    text-align: right;
    font-size: 0.8rem;
    color: #ffffff;
    opacity: 0.8;
  }
  .blog-title {
    text-align: left;
    margin-bottom: 0.25rem;
  }
  .cta-link {
    color: white;
    text-decoration: none;
  }
  @media only screen and (max-width: 600px) {
    .item-container {
      width: 50%;
      margin-right: 10px;
    }
  }
  </style>
  